import { useState } from "react";
import {
  useContentShareState,
  useContentShareControls,
} from "amazon-chime-sdk-component-library-react";
import VideoMeetingControlsContentShare from "./VideoMeetingControlsContentShare";
import { ContainerBreakpoints } from "../../videoMeeting.types";
import { videoEventBus } from "@core/features/video";

export type Props = {
  containerBreakpoints: ContainerBreakpoints;
};

export function VideoMeetingControlsContentShareContainer({
  containerBreakpoints,
}: Props) {
  const { isLocalUserSharing } = useContentShareState();
  const [isLoading, setIsLoading] = useState(false);

  const { toggleContentShare, togglePauseContentShare } =
    useContentShareControls();

  const handleToggle = async () => {
    if (isLoading) return;

    const isStarting = !isLocalUserSharing;

    if (isStarting) {
      setIsLoading(true);
    }

    try {
      await toggleContentShare();
      videoEventBus.emitEvent(
        isStarting ? "videochat:screen:shared" : "videochat:screen:unshared",
        {}
      );
    } catch (e) {
      // User cancelling the browser picker is normal flow, not an error
      if (e instanceof Error && e.name !== "NotAllowedError") {
        console.error("[ContentShare] Toggle failed:", e);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <VideoMeetingControlsContentShare
      isLocalUserSharing={isLocalUserSharing}
      isLoading={isLoading}
      onToggleContentShare={handleToggle}
      onTogglePauseContentShare={togglePauseContentShare}
      containerBreakpoints={containerBreakpoints}
    />
  );
}

export default VideoMeetingControlsContentShareContainer;
